export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const SIGNED_IN = 'SIGNED_IN';
export const COLOR = 'COLOR'
export const SELECTED_TAB = 'SELECTED_TAB'
export const FETCH_DATA_START = 'FETCH_DATA_START'
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS'
export const FETCH_DATA_FAILURE = 'FETCH_DATA_FAILURE'
export const CHANGE_THEME = 'CHANGE_THEME'